module.exports = __webpack_public_path__ + "static/thumbnail-roar-7c56811c33e8f339adbc522216fe43a6.jpg";